import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { navigateAddTask } from "../utilities/project-navigation"
import { useParams } from "react-router"
import { isGroupValid } from "../group/lib/is-group-valid"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"

export function AddTasksButton({ alternativeVariant }) {
    const { projectId, groupId } = useParams()
    const { hasAddedSchedules, group, project } = useBoundContext()
    const isLocked = isLockedToLegacy(project?.phase)
    const isValid = isGroupValid(group)
    let variant = isValid ? "outlined" : "contained"
    variant = alternativeVariant ?? variant

    return (
        <Button
            data-cy="add-task-button"
            variant={variant}
            startIcon={<Iconify icon="ic:round-add" />}
            onClick={() => navigateAddTask({ projectId, groupId })}
            disabled={!hasAddedSchedules || group.readOnly || isLocked}
        >
            Add Tasks
        </Button>
    )
}
